import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthModule } from '../../../modules/auth/auth.module';
import { AuthService } from '../modules/auth.service';
import { SnackBarService } from '../utils/snackBar.service';
import { HttpCodes } from '../../http/http-codes';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private authService: AuthService,
    private snackBarService: SnackBarService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const access_token: string = localStorage.getItem('access_token');

    // Leer el flag ANTES de clonar (se perderá en el stripeo)
    const skip412Toast = req.headers.has('X-Skip-412-Toast');

    let request = req;

    if (access_token) {
      request = req.clone({
        setHeaders: {
          authorization: `Bearer ${ access_token }`
        }
      });
    }

    // Siempre stripear la cabecera interna antes de enviar al servidor
    if (request.headers.has('X-Skip-412-Toast')) {
      request = request.clone({ headers: request.headers.delete('X-Skip-412-Toast') });
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {

        if (err.url && err.url.trim().includes('SurveySymptoms')) {
          this.router.navigateByUrl('/auth/AddSessionSymptomReport');

        } else if (err.status === 401) {
          this.authService.cleanSession();
          this.router.navigateByUrl('/auth/login');

        } else if (err.status === 412) {
          /*
           * 412 Precondition Failed
           * Si la petición incluía X-Skip-412-Toast, el componente maneja
           * el 412 localmente. El error siempre se re-lanza para que ese
           * handler pueda ejecutarse.
           */

          if (!skip412Toast) {
            const msg = err.error?.Message || err.error?.message
              || 'No se cumple una precondición requerida. Verifique los datos e intente de nuevo.';
            this.snackBarService.openWarning(msg, 'Precondición no cumplida');
          }

        } else if (err.status === 500 || err.status === 503) {
          this.snackBarService.openError(
            'Ocurrió un error en el servidor. Por favor intente de nuevo en un momento.',
            'Error del servidor'
          );

        } else if (err.status === 0) {
          this.snackBarService.openError(
            'No se pudo conectar con el servidor. Verifique su conexión a internet.',
            'Sin conexión'
          );
        }

        return throwError(err);
      })
    );
  }

}
